/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does box breathing work?`)
};

const es_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo funciona la respiración cuadrada?`)
};

const de_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktioniert Box-Breathing?`)
};

const nl_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe werkt box-breathing?`)
};

const fr_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne la respiration carrée ?`)
};

const it_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona il box breathing?`)
};

const pt_br2_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona a respiração quadrada?`)
};

const pt_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona a respiração em caixa?`)
};

const ja_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボックス呼吸はどのような仕組みですか？`)
};

const zh_timer_u1m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱式呼吸是如何进行的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_faq4_q", locale)
	if (locale === "en") return en_timer_u1m_faq4_q(inputs)
	if (locale === "es") return es_timer_u1m_faq4_q(inputs)
	if (locale === "de") return de_timer_u1m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u1m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u1m_faq4_q(inputs)
	if (locale === "it") return it_timer_u1m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u1m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u1m_faq4_q(inputs)
	return zh_timer_u1m_faq4_q(inputs)
};